// Resilient storage helpers. Hardened browsers (Brave Shields, Private mode,
// Firefox Focus) can throw when touching localStorage/IndexedDB. Never let that
// crash the app, degrade gracefully to an in-memory / no-persistence session.

export function storageAvailable() {
  try {
    const k = "__ss_probe__";
    window.localStorage.setItem(k, "1");
    window.localStorage.removeItem(k);
    return true;
  } catch {
    return false;
  }
}

export function indexedDbAvailable() {
  try {
    return typeof indexedDB !== "undefined" && indexedDB !== null;
  } catch {
    return false;
  }
}

export const safeLocal = {
  get(key) {
    try { return window.localStorage.getItem(key); } catch { return null; }
  },
  set(key, value) {
    try { window.localStorage.setItem(key, value); return true; } catch { return false; }
  },
  remove(key) {
    try { window.localStorage.removeItem(key); } catch { /* ignore */ }
  },
};
